import {
  displayRemoveGWPDisqualifyPopup,
  displayRemoveGWPDowngradePopup,
  displayRemoveGWPOutOfStockPopup,
  displayRemoveGWPWarningPopup,
} from 'services/actions/productsActions';
import { nextWithStock } from './thresholdCalculations';

const POPUP_TYPE = {
  DISQUALIFY: displayRemoveGWPDisqualifyPopup,
  OUT_OF_STOCK: displayRemoveGWPOutOfStockPopup,
  DOWNGRADE: displayRemoveGWPDowngradePopup,
  WARNING: displayRemoveGWPWarningPopup,
};

const gwpWarningPopUpBuilder = (dispatch) => {
  return (id) => dispatch(POPUP_TYPE.WARNING(id));
};

const mapDifferenceToPopUp = (difference, reachedGwpProducts) => {
  if (
    difference !== 0 &&
    reachedGwpProducts &&
    reachedGwpProducts.length === 0
  ) {
    return POPUP_TYPE.DISQUALIFY;
  }
  const nextAvailableProduct = nextWithStock(reachedGwpProducts);
  if (difference < 0) {
    const matchedProduct = reachedGwpProducts[0];
    const isLastProductSoldOut = matchedProduct && matchedProduct.soldOut;
    return (isLastProductSoldOut && nextAvailableProduct) ||
      !nextAvailableProduct
      ? POPUP_TYPE.OUT_OF_STOCK
      : POPUP_TYPE.DOWNGRADE;
  }
  return false;
};

const mapDifferenceToPopUpBuilder =
  (dispatch) => (difference, reachedGwpProducts) => {
    const popUp = mapDifferenceToPopUp(difference, reachedGwpProducts);
    return (id) => dispatch(popUp(id));
  };
export { gwpWarningPopUpBuilder, mapDifferenceToPopUpBuilder };
